import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { theme } from '@marriott/mi-ui-library-shop';
import { toRem } from '@marriott/mi-ui-library';

export const StyledFormContainer = styled.div.attrs(props => props)`
  ${rtl`
    &.serp-search-form-scrolled{
      min-height: auto; 
      @media ${theme.mediaQuery.mobileOnly} {
          min-height: auto;  
      } 
    }
    &.serp-search-form{
      min-height: ${toRem(160)}; 
      @media ${theme.mediaQuery.mobileOnly} {
          min-height: auto;  
      }
    }
  `}
`;
